// This file contains utility functions that are used in the dashboard
import { WebMercatorViewport, LinearInterpolator } from 'react-map-gl';
import bbox from '@turf/bbox';
import { defaultViewPort } from './globals.js';

export const getJsonData = async (indexName, regionName="NSW") => {
    const filePrefix = "AGCD_"
    const fileSuffix = "_ANN_1910-2022.json"
    // Construct the URL to the JSON file in the public folder
    const fileName = `${filePrefix}${indexName}_${regionName}${fileSuffix}`;
    const fileUrl = `data/json/${fileName}`;
    console.log("File URL: ", fileUrl)
    const response = await fetch(fileUrl);
    const data = await response.json();
    return data;
}

// Function for when you click outside australia, resets to Australia
export function setDefaultViewPort(setViewport) {
    setViewport({
        ...defaultViewPort,
        transitionDuration: 700,
        transitionInterpolator: new LinearInterpolator()
    });      
}

export function viewRegion(event, feature, viewport, setViewport) {
    const vp = new WebMercatorViewport(viewport);
    const [minLng, minLat, maxLng, maxLat] = bbox(feature);
    const {longitude, latitude, zoom} = vp.fitBounds(
      [
        [minLng, minLat],
        [maxLng, maxLat]
      ],
      {
        padding: 100
      }
    );
    setViewport({
      ...viewport,
      longitude,
      latitude,
      zoom,
      transitionDuration: 700,
      transitionInterpolator: new LinearInterpolator()
      });
    };